import { render, staticRenderFns } from "./notaLista.vue?vue&type=template&id=d9dc6424&scoped=true"
import script from "./notaLista.vue?vue&type=script&lang=js"
export * from "./notaLista.vue?vue&type=script&lang=js"
import style0 from "./notaLista.vue?vue&type=style&index=0&id=d9dc6424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9dc6424",
  null
  
)

export default component.exports